export const rules = {
  sanitize: false,
};

// list of number formats to be used in range step calculation
export const numberRangeFormats = ["{0:n3}", "{0:c0}"];

/**
 * This is a map of v12.x elements to new component types.
 * Ideally these types are moved to the API.
 */
export const types = [
  {
    element: "date",
    properties: {
      element: "input",
      type: "date",
    },
  },
  {
    element: "dateRange",
    properties: {
      element: "input",
      type: "date_range",
    },
  },
  {
    // integer range input
    element: "numberRange",
    properties: {
      element: "input",
      type: "numeric_range",
      datatype: "integer",
      decimals: null,
      format: "{0:n0}",
    },
  },
  {
    // decimal range input
    element: "numberRangeDecimal",
    properties: {
      element: "input",
      type: "numeric_range",
      datatype: "decimal",
      decimals: "2",
      format: "{0:n2}",
    },
  },
  {
    // currency range input
    element: "numberRangeCurrency",
    properties: {
      element: "input",
      type: "numeric_range",
      datatype: "currency",
      decimals: "2",
      format: "{0:c2}",
    },
  },
  {
    // RVC float range input
    element: "numberRangeFloat",
    properties: {
      element: "input",
      type: "numeric_range",
      datatype: "float",
      decimals: "3",
      format: "{0:n3}",
    },
  },
  {
    // integer range slider
    element: "dataRange",
    properties: {
      element: "select",
      type: "range_slider",
      datatype: "integer",
      format: "{0:#}",
    },
  },
  {
    // float range slider
    element: "dataRangeFloat",
    properties: {
      element: "select",
      type: "range_slider",
      datatype: "float",
      format: "{0:n3}",
    },
  },
  {
    // currency range slider
    element: "dataRangeCurrency",
    properties: {
      element: "select",
      type: "range_slider",
      datatype: "currency",
      format: "{0:c0}",
    },
  },
  {
    element: "select",
    properties: {
      element: "select",
      type: "single",
    },
  },
  {
    element: "multiSelect",
    properties: {
      element: "select",
      type: "multiple",
    },
  },
  {
    element: "multiSelectWithDescription",
    properties: {
      element: "select",
      type: "multiple_with_desc",
    },
  },
  {
    element: "checkbox",
    properties: {
      element: "input",
      type: "checkbox",
    },
  },
  {
    element: "radio",
    properties: {
      element: "select",
      type: "radio",
    },
  },
];
